import { useIntl } from 'react-intl'

import useLocalStorage from '../../../../app/hooks/useLocalStorage'
import CinemaTypeImg from '../../../../components/CinemaTypeImg/CinemaTypeImg'
import { PAGE_NAME } from '../../../../components/OrderStepsHeader/constants'
import Typography from '../../../../components/Typography/Typography'
import InfoWindow from '../../../../components/Windows/InfoWindow/InfoWindow'
import TicketTypes from '../../../../components/Windows/InfoWindow/components/TicketTypes/TicketTypes'
import { getCinemaType } from '../../../../global/helpers'
import HallMovie from '../../../Hall/components/HallMovie/HallMovie'
import SubMovieImg from '../SubMovieImg/SubMovieImg'
import TicketRow from './components/TicketRow/TicketRow'
import TicketRowHeader from './components/TicketRowHeader/TicketRowHeader'

import './MovieRow.scss'

const MovieRow = ({ firstMovie = true, movie, page, tickets, loading }) => {
    const intl = useIntl()
    const [ticketTypes, setTicketTypes] = useLocalStorage('showInfoTicketTypes', false)

    const cinemaType = getCinemaType(movie?.event_properties)

    return (
        <div className={'your-order-movie-row d-flex flex-column'}>
            {firstMovie ? (
                <CinemaTypeImg
                    cinemaType={cinemaType}
                    page={PAGE_NAME.yourOrder}
                    imgUrl={movie?.imageUrl}
                    imgAlt={movie?.title}
                />
            ) : (
                <SubMovieImg cinemaType={cinemaType} imgUrl={movie?.imageUrl} imgAlt={movie?.title} />
            )}
            <HallMovie cinemaType={cinemaType} movie={movie} page={page} disable={false} loading={loading} />
            {firstMovie && ticketTypes && (
                <InfoWindow
                    title={intl.formatMessage({ id: 'windows.info.ticketTypes.title' })}
                    color={'blue'}
                    element={<TicketTypes />}
                    onClose={() => setTicketTypes(false)}
                    isOpen={ticketTypes}
                    withScroll
                />
            )}
            {/* TODO handle if it will be in data <InfoWindow
                color={'purple'}
                description={intl.formatMessage({ id: 'windows.notification.withoutPoints' })}
            /> */}
            <div className={'tickets-wrapper d-flex flex-column'}>
                <Typography variant={'sectionHeadline'}>
                    {intl.formatMessage({ id: 'yourOrder.tickets.title' })}
                </Typography>
                <div className={'tickets'}>
                    <TicketRowHeader firstMovie={firstMovie} onClick={() => setTicketTypes(true)} />
                    {tickets?.map((ticket) => (
                        <TicketRow data={ticket} key={ticket.ticketid} loading={loading} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default MovieRow
